/**
 * 自定义公式编辑器风格
 */
import CodeMirror from 'codemirror'
import { util } from './formulaUtil'

let aCondition = util._aLogicFn;
let aFunction = util._aFunction;

let conditionsRegex = new RegExp("\\b((" + aCondition.join(")|(") + "))", 'i');
let functionsRegex = new RegExp("\\b((" + aFunction.join(")|(") + "))", 'i');

//自定义全局成员列表
let memberNameArr = (list) => {
    let arr = [];
    for (let i = 0; i < list.length; i++) {
        arr.push(`\$\{${list[i].name}\}`);
    }
    return arr;
}

//自定义函数列表
let fnNameArr = (dict) => {
    let arr = [];
    for (let i in dict) {
        arr.push(i);
    }
    return arr;
}

let _memberList = memberNameArr(util._aMembers)
let _functionList = fnNameArr(util._calcFn)

//公式语法高亮解析
let formulaToken = (stream, state) => {
    if (stream.eatSpace()) {
        return null;
    }
    if (stream.match(util.REGEX.memberWithBracket)) {
        return "member";
    } else if (stream.match(conditionsRegex)) {
        return "condition";
    } else if (stream.match(functionsRegex)) {
        return "function";
    } else if (stream.match(/(\${)[a-zA-Z0-9]*(})/)) {
        return "constant";
    } else if (stream.match(/[true|false|null]/i)) {
        return "boolean";
    } else if (stream.match(/^[0-9.]+/)) {
        return "number";
    } else if (stream.match(/^[\+|\-|\*|\/]/g)) {
        return "arithmetic";
    } else if (stream.match(/^=\s*=/)) {
        return "error";
    } else if (stream.match(/^[<\s*=|>\s*=|=|!\s*=|<|>]/g)) {
        return "bool";
    } else if (stream.match(/^[,|;]/)) {
        return "comma";
    } else if (stream.match(/^[(|\[|)|\]]/)) {
        return "bracket";
    } else if (stream.match(/"(?:[^"\\]|\\.)*"/)) {
        return "string";
    } else {
        stream.next();
        return "error";
    }
}

//自动联想索引提示
let hint = (editor, options) => {
    options.completeSingle = false;
    let cur = editor.getCursor(), curLine = editor.getLine(cur.line);
    let inputChart = curLine.charAt(cur.ch - 1)
    let word = '', regex = /[a-zA-Z]+/gi, res

    if (inputChart === "$") { //"["
        return {
            list: _memberList,
            from: CodeMirror.Pos(cur.line, cur.ch - 1),
            to: CodeMirror.Pos(cur.line, cur.ch)
        };
    } else if (!/[a-zA-Z]+/.test(inputChart)) {
        return
    }

    curLine = curLine.substr(0, cur.ch)
    while ((res = regex.exec(curLine)) != null) {
        word = res[0];
    }

    let hint = [];
    let reg = new RegExp(`^${word}`,"i");
    for (let i = 0; i < _functionList.length; i++) {
        let curr = _functionList[i];
        if (reg.test(curr)) {
            hint.push(curr);
        }
    }
    if (hint.length > 0) {
        return {
            list: hint,
            from: CodeMirror.Pos(cur.line, cur.ch - word.length),
            to: CodeMirror.Pos(cur.line, cur.ch)
        };
    }
}

//获取所有明细节点
let getTreeDetailNodes = (tree, arr) => {
    if (!arr) arr = []
    tree.forEach((currentValue) => {
        if (!currentValue.children) {
            arr.push(currentValue)
        } else {
            arr.join(getTreeDetailNodes(currentValue.children, arr))
        }
    })
    return arr
}

//自定义语法构造器
export let builder = {
    init: (functions, constants) => {
        if (functions) {
            let retArr = getTreeDetailNodes(functions)
            let _calcFn = {}
            
            retArr.forEach((currentValue, index, arr) => {
                if (!currentValue.children) {
                    _calcFn[currentValue.name] = {
                        op: currentValue.name,
                        priority: 0,
                        opNum: currentValue.params.length,
                        type: 'function',
                        calc: currentValue.calc
                    }
                }
            });
            aFunction = Object.keys(_calcFn)
            conditionsRegex = new RegExp("\\b((" + aCondition.join(")|(") + "))", 'i');
            functionsRegex = new RegExp("\\b((" + aFunction.join(")|(") + "))", 'i');
            _functionList = fnNameArr(_calcFn)
        }
        if (constants) {
            _memberList = memberNameArr(constants)
        }
    },
    doRegister: () => {
        CodeMirror.defineMode('webFormula', function (conf, parserConf, functionsRegex) {
            return {
                startState: function () {
                    return {
                        context: 0,
                        sTemp: ""
                    };
                },
                token: function (stream, state) {
                    return formulaToken(stream, state);
                }
            };
        });
        CodeMirror.defineMIME("text/x-webFormula", "webFormula");
        CodeMirror.registerHelper("hint", "webFormula", hint);
    }
}
